import { parseRecordCapabilities, type RecordCapabilities } from "./recordCapabilities";

/** Normalize audit metadata field names from various backend conventions */
export interface BusinessObjectMetadata {
  createdAt?: string;
  createdBy?: string;
  updatedAt?: string;
  updatedBy?: string;
  /** Instance + context rights from the record envelope, when present. */
  capabilities?: RecordCapabilities;
  /** `ACTIVE` or `DELETED`. List routes can still return a deleted row. */
  recordState?: string;
}

const getStringValue = (raw: Record<string, unknown>, ...keys: string[]): string | undefined => {
  for (const key of keys) {
    const value = raw[key];

    if (typeof value === "string" && value.trim()) {
      return value;
    }
  }

  return undefined;
};

export const normalizeBusinessObjectMetadata = (
  raw: Record<string, unknown> | undefined,
): BusinessObjectMetadata => {
  if (!raw) {
    return {};
  }

  return {
    createdAt: getStringValue(raw, "createdAt", "createAt", "created_at"),
    createdBy: getStringValue(raw, "createdBy", "createBy", "created_by"),
    updatedAt: getStringValue(raw, "updatedAt", "updateAt", "updated_at", "lastUpdatedAt"),
    updatedBy: getStringValue(raw, "updatedBy", "updateBy", "updated_by"),
    capabilities: parseRecordCapabilities(raw.capabilities ?? raw.permissions),
    recordState: getStringValue(raw, "recordState"),
  };
};
